"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStatusBefore = exports.statusInfo = exports.UserListItemStatus = void 0;
var UserListItemStatus;
(function (UserListItemStatus) {
    UserListItemStatus["REMOVED"] = "removed";
    UserListItemStatus["ACTIVE"] = "active";
    UserListItemStatus["APPLIED"] = "applied";
})(UserListItemStatus = exports.UserListItemStatus || (exports.UserListItemStatus = {}));
;
exports.statusInfo = {
    [UserListItemStatus.REMOVED]: {
        status: UserListItemStatus.REMOVED,
        label: "Removed",
        order: 0,
        next: UserListItemStatus.ACTIVE
    },
    [UserListItemStatus.ACTIVE]: {
        status: UserListItemStatus.ACTIVE,
        label: "Favorited",
        order: 1,
        next: UserListItemStatus.APPLIED
    },
    [UserListItemStatus.APPLIED]: {
        status: UserListItemStatus.APPLIED,
        label: "Application in Review",
        order: 2,
        next: undefined
    }
};
const isStatusBefore = (statusA, statusB) => { var _a, _b; return (((_a = exports.statusInfo[statusB]) === null || _a === void 0 ? void 0 : _a.order) - ((_b = exports.statusInfo[statusA]) === null || _b === void 0 ? void 0 : _b.order)) > 0; };
exports.isStatusBefore = isStatusBefore;
